module.exports = __webpack_public_path__ + "static/img/articles.fe53a47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/visuels/articles.png
// module id = 9IHe
// module chunks = 1